import { memo } from 'react';
import { Box, Button } from '@mui/material';
import { environment } from 'apps/table-tuck-web/src/environments/environment';

/**
 * Order type toggle (Delivery/Pickup)
 * Memoized to prevent unnecessary re-renders
 */
const OrderTypeToggle = memo(
  ({
    orderType,
    onOrderTypeChange,
    enablePickup = true,
    enableDelivery = true,
    locked = false,
  }) => {
    const types = ['delivery', 'pickup'];
    const typeLabels = {
      delivery: 'Delivery',
      pickup: 'Pickup',
    };

    return (
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          justifyContent: 'center',
          padding: '20px 5%',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            backgroundColor: '#F5F5F5',
            borderRadius: '50px',
            padding: '4px',
            width: '100%',
            maxWidth: '400px',
          }}
        >
          {types.map((type) => {
            const isDisabled =
              (type === 'delivery' && !enableDelivery) ||
              (type === 'pickup' && !enablePickup);

            if (isDisabled) return null;

            const isActive = orderType === type;
            const isLocked = locked && !isActive;

            return (
              <Button
                key={type}
                disableRipple
                disabled={isLocked}
                sx={{
                  flex: 1,
                  margin: '0 2px',
                  backgroundColor: isActive
                    ? environment.mainColor
                    : 'transparent',
                  textShadow: isActive
                    ? '0 1px 3px rgba(0, 0, 0, 0.3)'
                    : 'none',
                  color: isActive ? 'white' : '#8E8E93',
                  borderRadius: '46px',
                  fontFamily: 'Jost, sans-serif',
                  fontWeight: '600',
                  fontSize: '14px',
                  textTransform: 'capitalize',
                  padding: '4px',
                  minHeight: '44px',
                  boxShadow: 'none',
                  border: 'none',
                  transition: 'all 0.2s ease',
                  cursor: isLocked ? 'not-allowed' : 'pointer',
                  opacity: isLocked ? 0.4 : 1,
                  '&:hover': {
                    backgroundColor: isActive
                      ? environment.mainColor
                      : isLocked ? 'transparent' : '#E0E0E0',
                    boxShadow: 'none',
                  },
                  '&.Mui-disabled': {
                    color: '#8E8E93',
                    backgroundColor: 'transparent',
                  },
                }}
                variant={isActive ? 'contained' : 'text'}
                onClick={() => !isLocked && onOrderTypeChange(type)}
              >
                {typeLabels[type]}
              </Button>
            );
          })}
        </Box>
      </Box>
    );
  }
);

OrderTypeToggle.displayName = 'OrderTypeToggle';

export default OrderTypeToggle;
